import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { bibShape, paginationShape } from '@bibliocommons/bc-prop-types';

import { selectAddTitleResult } from 'app/selectors/SearchSelector';
import SearchActions from 'app/actions/SearchActions';
import AvailabilityDetailActions from 'app/actions/AvailabilityDetailActions';
import { searchQueryShape } from 'app/shapes/search';
import { AddTitle } from './AddTitle';

export class AddTitleContainer extends React.PureComponent {
  render() {
    const {
      addTitleResult,
      searchActions,
      availabilityDetailActions,
      isUpdatingResultItem,
      isWrappedInForm
    } = this.props;
    return (
      <div>
        <AddTitle
          isUpdatingResultItem={isUpdatingResultItem}
          searchActions={searchActions}
          availabilityDetailActions={availabilityDetailActions}
          searchQuery={addTitleResult.get('searchQuery')}
          pagination={addTitleResult.get('pagination')}
          zeroResults={addTitleResult.get('zeroResults')}
          results={addTitleResult.get('items')}
          isFetching={addTitleResult.get('isFetching')}
          handleClose={this.props.handleClose}
          renderAddOn={this.props.renderAddOn}
          addRowClassNames={this.props.addRowClassNames}
          renderAlert={this.props.renderAlert}
          isWrappedInForm={isWrappedInForm}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  addTitleResult: selectAddTitleResult(state)
});

const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch),
  availabilityDetailActions: bindActionCreators(AvailabilityDetailActions, dispatch)
});

AddTitleContainer.propTypes = {
  searchActions: PropTypes.objectOf(PropTypes.func).isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired,
  addTitleResult: ImmutablePropTypes.contains({
    searchQuery: searchQueryShape.isRequired,
    zeroResults: PropTypes.bool.isRequired,
    pagination: paginationShape.isRequired,
    items: ImmutablePropTypes.listOf(bibShape).isRequired,
    isFetching: PropTypes.bool
  }).isRequired,
  handleClose: PropTypes.func.isRequired,
  renderAlert: PropTypes.func,
  addRowClassNames: PropTypes.func,
  renderAddOn: PropTypes.func,
  isUpdatingResultItem: PropTypes.bool,
  isWrappedInForm: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(AddTitleContainer);
